@if (isSpinnerShow) {
  <app-simple-loader />
}
@if (aiProcessingService.modalVisible$ | async) {
  <app-ai-processing-modal />
}
@if (aiProcessingService.fabVisible$ | async) {
  <app-ai-fab />
}
<app-toast />
<!-- <app-conversation-agent-fab /> -->
<router-outlet></router-outlet>
